import classNames from 'classnames';
import React from 'react';
import styles from './login-streak.module.css';

export type Days = 'SUN' | 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT';

export function LoginStreak(props: { dates?: Date[]; days?: Days[] }): JSX.Element {
  const abbreviations: Days[] = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const days: Days[] = props.days ?? abbreviations;

  let indices = days.map((day, index) => index);
  if (!!props.dates) {
    indices = props.dates.map(date => {
      const abbreviation = abbreviations[date.getDay()];
      return days.findIndex(day => day === abbreviation);
    });
  }

  return (
    <ul className={styles.days}>
      {days.map((day, index) => {
        return (
          <li key={day} className={styles.day}>
            <small style={{ marginBottom: '5px', textAlign: 'center' }}>{day}</small>
            <div className={classNames(styles.placeholder, { [styles.active]: indices.includes(index) })} />
          </li>
        );
      })}
    </ul>
  );
}
